import { render, staticRenderFns } from "./TakipTahsilatWidget.vue?vue&type=template&id=538959e5&scoped=true"
import script from "./TakipTahsilatWidget.vue?vue&type=script&lang=ts"
export * from "./TakipTahsilatWidget.vue?vue&type=script&lang=ts"
import style0 from "./TakipTahsilatWidget.vue?vue&type=style&index=0&id=538959e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538959e5",
  null
  
)

export default component.exports